<template>
  <el-card class="steps">
    <div class="step-list">
      <div 
        v-for="(item, index) in stepItems" 
        :key="index"
        :class="['step-item', { active: index <= active }]"
      >
        <span>{{item}}</span>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'steps',
  props: {
    active: {
      type: Number,
      default: 0
    },
    stepItems: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .el-card__body, .el-main {
  padding: 10px;
}
.steps {
  margin-bottom: 16px;

  .step-list {
    display: flex;
    width: 100%;
    
    .step-item {
      position: relative;
      flex: 1;
      height: 40px;
      line-height: 40px;
      background: #f5f7fa;
      color: #909399;
      text-align: center;
      transition: all 0.3s;
      margin-right: 10px;
      &:last-child {
        margin-right: 0;
        &::after {
          display: none;
        }
      }
      
      &::after {
        content: '';
        position: absolute;
        right: -20px;
        top: 0;
        border-top: 20px solid transparent;
        border-bottom: 20px solid transparent;
        border-left: 20px solid #f5f7fa;
        z-index: 1;
        transition: all 0.3s;
      }
      
      &:not(:first-child)::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        border-top: 20px solid transparent;
        border-bottom: 20px solid transparent;
        border-left: 20px solid #fff;
      }
      
      &.active {
        background: #409EFF;
        color: #fff;
        
        &::after {
          border-left-color: #409EFF;
        }
      }
      
      span {
        position: relative;
        z-index: 2;
        padding: 0 10px;
      }
    }
  }
}
</style>
